import { CellProps } from 'react-table';
import AutocompleteV2 from '../../../../component/AutocompleteObjectV2';
import EditableCell from './EditableCell';

const ObjectTypeCell = ({ row, tableOptions }: CellProps<any>) => {
	const { updateRowData, listDoiTuong } = tableOptions;
	const rowData = row.original;

	return (
		<EditableCell
			editComponent={({ setEnableEditing }: any) => {
				return (
					<AutocompleteV2
						autoFocus
						options={listDoiTuong || []}
						value={rowData?.visitObjectType}
						name="visitObjectType"
						onChange={(selectedOption) => {
							updateRowData(row.index, "visitObjectType", selectedOption);
							setEnableEditing(false);
						}}
						onBlur={() => {
							setEnableEditing(false);
						}}
						className="border-0"
						isClearable={false}
						styles={{
							menu: (provided: any) => ({
								...provided,
								minWidth: 150,
							}),
						}}
					/>
				);
			}}
			textValue={rowData?.visitObjectType?.name}
		/>
	);
};

export default ObjectTypeCell;
